import React from "react";
import { Link } from "react-router-dom";
import { company } from "../data/siteData";
import SectionTitle from "./SectionTitle";

export default function CompanyPreview() {
  return (
    <section className="company-preview section">
      <div className="container company-preview__grid">
        <div>
          <SectionTitle
            label="06 — COMPANY"
            title={
              <>
                信用を、
                <br />
                事業の土台に。
              </>
            }
          />
          <p className="company-preview__lead">
            埼玉から、全国のビジネスへ。
            <br />
            一つひとつの取引に、誠実に向き合います。
          </p>
          <Link className="text-link" to="/company">
            会社概要・代表挨拶 <span>↗</span>
          </Link>
        </div>
        <dl className="company-preview__table">
          {[
            ["会社名", company.name],
            ["設立", company.established],
            ["所在地", company.address],
            ["代表取締役", company.representative],
            ["事業内容", "酒類卸売・小売／法人向け仕入支援／EC"],
          ].map(([k, v]) => (
            <div key={k}>
              <dt>{k}</dt>
              <dd>{v}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}
